"use client";

import { useId } from "react";

export function AgreementTitle({ documentLabel, onOpen, disabled = false }: {
  documentLabel: string;
  onOpen: () => void;
  disabled?: boolean;
}) {
  return <div className="agreement-title rounded-xl border border-[var(--color-line)] bg-[var(--color-sunken)] px-4 py-3">
    <button type="button" disabled={disabled} className="min-h-11 w-full text-left text-sm font-semibold leading-7 disabled:opacity-50" onClick={onOpen}>《{documentLabel}》</button>
  </div>;
}

export function AgreementConfirmation({ checked, onChange, onOpen, documentLabel, statement, suffix = "。", showTitle = false, compact = false, disabled = false, readDisabled = disabled, name, required }: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onOpen: () => void;
  documentLabel: string;
  statement: string;
  suffix?: string;
  showTitle?: boolean;
  compact?: boolean;
  disabled?: boolean;
  readDisabled?: boolean;
  name?: string;
  required?: boolean;
}) {
  const id = useId();
  const punctuation = /^[。，；、！？]/u.test(suffix) ? suffix[0] : "";
  return <div className="grid gap-3">
    {showTitle && !compact && <AgreementTitle documentLabel={documentLabel} onOpen={onOpen} disabled={readDisabled} />}
    <div className={compact ? "rg-consent flex items-start gap-2 text-xs leading-6 text-[var(--color-muted)]" : "agreement-confirmation-panel flex items-start gap-3 rounded-xl border border-[var(--color-line)] bg-[var(--color-accent-soft)] px-4 py-3 text-sm leading-7"}>
      <input id={id} type="checkbox" name={name} value="yes" required={required}
        className="mt-1.5 h-4 w-4 shrink-0 accent-[var(--color-accent)]"
        checked={checked} disabled={disabled} aria-labelledby={`${id}-label`}
        onChange={event => onChange(event.currentTarget.checked)} />
      <span id={`${id}-label`}>
        <label htmlFor={id}>{statement}</label>
        <button type="button" disabled={readDisabled} className="inline text-left disabled:opacity-50" onClick={onOpen}><span className="underline underline-offset-4">《{documentLabel}》</span>{punctuation}</button>{suffix.slice(punctuation.length)}
      </span>
    </div>
  </div>;
}
